function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.5,21.7l-7.8-7.8c-1.6-1.6-3.2-3.2-4.8-4.8C7,8.5,6.9,7.3,7.5,6.5c0.1-0.1,0.2-0.2,0.3-0.3C9,5,10.2,3.8,11.4,2.6 c0.6-0.8,1.7-0.9,2.5-0.3C14,2.4,14,2.5,14.1,2.6l17.8,17.8c0.8,0.5,1,1.6,0.5,2.3c-0.1,0.2-0.3,0.3-0.5,0.5 C26,29.1,20.1,35,14.1,40.9c-0.6,0.8-1.7,0.9-2.4,0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-1.2-1.2-2.3-2.3-3.5-3.5s-1-2,0-3 c3.9-4,7.9-7.9,11.9-11.9C20,22.2,20.2,22,20.5,21.7z"
});

var SvgChevronRight = function SvgChevronRight(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.7 42.5",
    style: {
      enableBackground: "new 0 0 39.7 42.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-right.d02c52ce.svg";
export { ForwardRef as ReactComponent };